"use client";

/**
 * PostDetailLanguageLink 컴포넌트
 * @description 헤더의 언어 전환 한 칸 — 같은 글의 [language] 판으로 가는 링크. 그 언어로 쓴 제
 *   이름("Español")을 적는다. 누르면 어디서 어디로 옮겼는지 남긴다.
 *
 *   버튼이 아니라 링크다 — 검색 엔진이 따라가 다른 언어 판을 찾고, 새 탭으로도 열린다.
 *   `hrefLang`·`lang` 으로 이동할 곳과 이름의 언어를 알린다.
 */
import { buttonStyles } from "@fanwork-web/design-system";
import { Languages } from "lucide-react";
import Link from "next/link";
import { memo, useCallback } from "react";

import { postDetailStyles } from "./PostDetail.styles";
import type { PostDetailLanguageLinkProps } from "./PostDetail.types";

import { trackBlogLanguageSwitched } from "../../analytics";
import { BLOG_LANGUAGE_NAMES } from "@/shared/config";
import { routes } from "@/shared/config/routes";

const ICON_SIZE = 16;

const PostDetailLanguageLink = memo<PostDetailLanguageLinkProps>(
  ({ post, language }) => {
    const track = useCallback(
      () => trackBlogLanguageSwitched(post, language),
      [post, language],
    );
    return (
      <Link
        href={routes.blog.detail(post.slug, language)}
        hrefLang={language}
        lang={language}
        onClick={track}
        className={buttonStyles({
          tone: "ghost",
          size: "sm",
          radius: "circle",
          className: postDetailStyles.languageLink,
        })}
      >
        <Languages aria-hidden size={ICON_SIZE} strokeWidth={2} />
        <span className="truncate">{BLOG_LANGUAGE_NAMES[language]}</span>
      </Link>
    );
  },
);

PostDetailLanguageLink.displayName = "PostDetailLanguageLink";

export default PostDetailLanguageLink;
